//course types mapping
const types = [
   {
     id: "undergrad",
     label: "Undergraduate Degree (Bachelors)",
     courseloop: "Undergraduate,Honours,Cross Institution Program,Non-Award Course"
   },
   {
     id: "postgrad",
     label: "Postgraduate Degree by Coursework",
     courseloop: "Postgraduate"
   },
   {
     id: "research",
     label: "Research Degree",
     courseloop: "Research"
   }
]

class CourseType {

   static getTypes(){
      return types
   }

}

module.exports = CourseType
